import EA from 'helpers/init';
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

export default EA.Methods.aboutSlider = ($this) => {
    const slider = $this.querySelector('.swiper');
    const prev = $this.querySelector('.prev');
    const next = $this.querySelector('.next');
    const scrollbar = $this.querySelector('.swiper-scrollbar');

    new Swiper(slider, {
        modules: [Navigation, Scrollbar],
        speed: 1200,
        slidesPerView: 1.2,
        spaceBetween: 20,
        allowTouchMove: true,
        slidesOffsetBefore: 20,
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        scrollbar: {
            el: scrollbar,
            draggable: true
        },
        breakpoints: {
            601: {
                slidesPerView: 2.4,
                spaceBetween: 18,
                slidesOffsetBefore: 0
            },
            1001: {
                slidesPerView: 2.8,
                spaceBetween: 18,
                slidesOffsetBefore: 0
            },
            1201: {
                slidesPerView: 3.745,
                spaceBetween: 18,
                slidesOffsetBefore: 0
            }
        }
    });
};
